import { configureStore } from "@reduxjs/toolkit";
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from "redux-persist";
import storage from "redux-persist/lib/storage";
import createSagaMiddleware from "redux-saga";
import rootReducer from "../RootReducer/rootReducer";
import rootSaga from "../RootSaga/rootSaga";

const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["values"],
  blacklist: [],
  version: 1,
  migrate: (state, done) => {
    return Promise.resolve(state).then(done);
  },
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER, 
          'FETCH_LIST_PATIENTS_SUCCESS',
          'FETCH_LIST_ADMISSIONS_SUCCESS', 
          'HISTORY_PATIENTS_SUCCESS',
          'FETCH_LIST_SECURITY_OFFICERS_SUCCESS'
        ],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.patients.headers', 'payload.admissions.headers', 'payload.securityOfficers.headers'],
      },
    }).concat(sagaMiddleware),
  devTools: true,
});

sagaMiddleware.run(rootSaga);

const persistor = persistStore(store);

export { persistor, store };

